import styled from 'styled-components';
import { Button } from '../Buttons/ButtonV2/index.js';
import { DismissingCard } from '../DismissingCard/index.js';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-ad0bdb10-0"
})`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: ${(props)=>props.theme.colors.secondaryBackground};
`;
const BadgeContainer = styled.div.withConfig({
    displayName: "styles__BadgeContainer",
    componentId: "sc-ad0bdb10-1"
})`
    padding: 6px 0;
    display: flex;
    flex-direction: row;
`;
const Wrap = styled.div.withConfig({
    displayName: "styles__Wrap",
    componentId: "sc-ad0bdb10-2"
})`
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    cursor: pointer;
`;
const Text = styled.p.withConfig({
    displayName: "styles__Text",
    componentId: "sc-ad0bdb10-3"
})`
    flex: 1 1 auto;
    line-height: 24px;
    margin: 0 0 0 10px;
    color: ${(props)=>props.theme.colors.secondary};
    ${({ theme  })=>theme.typography.Paragraph}
`;
const BadgeDismissingCard = styled(DismissingCard).withConfig({
    displayName: "styles__BadgeDismissingCard",
    componentId: "sc-ad0bdb10-4"
})`
    background-color: transparent;
    margin: 0;
    border: none;
    padding: 8px 14px;
`;
const CircleDismissButton = styled(Button).withConfig({
    displayName: "styles__CircleDismissButton",
    componentId: "sc-ad0bdb10-5"
})`
    margin-left: 10px;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 12px;
    padding: 0;
    min-width: auto;
    background-color: transparent;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export { BadgeContainer, BadgeDismissingCard, CircleDismissButton, Container, Text, Wrap };
